import { useTranslateWithL10nLoader, useFormatters } from '@sqs/i18n-react';

export function useI18n() {
  const { t, T } = useTranslateWithL10nLoader();
  const { formatDate } = useFormatters();
  const formatDateGeneric = (date: Date | string) => {
    const d = new Date(date);
    return formatDate(d, { date: 'long' });
  };

  return { t, T, formatDate, formatDateGeneric };
}
